import React from 'react'
import type { BusyButtonProps } from './index'
import { BusyButton } from './index'

const mapBsStyleToTextClass = (bsStyle?: string) => {
  if (!bsStyle) return ''
  return `text-${bsStyle}`
}

export const BusyButtonLink = ({ className, style, bsStyle = 'primary', ...props }: BusyButtonProps) => {
  const textColorClass = mapBsStyleToTextClass(bsStyle)
  const computedClassName = `fw-bold text-decoration-none p-0 m-0 ${textColorClass} ${className ?? ''}`.trim()

  return (
    <BusyButton
      {...props}
      variant="link"
      bsStyle="link"
      className={computedClassName}
      style={style ?? { lineHeight: 0.4 }}
    />
  )
}
